import React, { Component } from 'react';

import { Slide } from 'react-slideshow-image';

import Img1 from '../assets/fertilizzanti.jpg';
import Img2 from '../assets/growbox.jpeg';
import Img3 from '../assets/growplant.jpg';
import Img4 from '../assets/illuminazione.jpeg';
import Img5 from '../assets/terra.jpeg';
import Img6 from '../assets/terra2.jpeg';
import Img7 from '../assets/growproduct.JPG';

import '../App.css';


const slideGrowImages = [
  Img1,
  Img2,
  Img3,
  Img4,
  Img5,
  Img6,
  Img7
];

const propertiesGrow = {
  duration: 4000,
  transitionDuration: 400,
  infinite: true,
  indicators: true,
  arrows: false,
}

class GrowShop extends Component {
  render() {
    return (
      <div className="App">
      <div className ="prod-title">
        <h1>Grow Shop - articoli per la coltivazione indoor</h1>
        <br />
      </div>

      <Slide {...propertiesGrow}>
        <div className="grow-slide">
          <img src={slideGrowImages[0]} alt="Prodotti per la coltivazione indoor" title="Fertilizzanti" />
        </div>
        <div className="grow-slide">
          <img src={slideGrowImages[1]} alt="Prodotti per la coltivazione indoor" title="Grow box e vasi" />
        </div>
        <div className="grow-slide">
          <img src={slideGrowImages[2]} alt="Prodotti per la coltivazione indoor" title="Piantine in grow box" />
        </div>
        <div className="grow-slide">
          <img src={slideGrowImages[3]} alt="Prodotti per la coltivazione indoor" title="Varia illuminazione e ventilazione" />
        </div>
        <div className="grow-slide">
          <img src={slideGrowImages[4]} alt="Prodotti per la coltivazione indoor" title="Terra" />
        </div>
        <div className="grow-slide">
          <img src={slideGrowImages[5]} alt="Prodotti per la coltivazione indoor" title="Terra in magazzino" />
        </div>
      </Slide>

      <div className="prod-grow">
      <ul>
        <li><h4>SEMI</h4></li>
        <li><h4>FERTILIZZANTI</h4></li>
        <li><h4>MISURAZIONE LIQUIDI E pH</h4></li>
        <li><h4>GROW BOX</h4></li>
      </ul><ul>
        <li><h4>ILLUMINAZIONE</h4></li>
        <li><h4>VENTILAZIONE</h4></li>
        <li><h4>IDROPONICA</h4></li>
        <li><h4>TERRA E VASI</h4></li>
      </ul>
      </div>
      </div>
    )
  }
}


export default GrowShop;
